export { OrderItemCardComponent } from './order-item-card/order-item-card.component';
export {
  OrdersResourceDetailComponent,
  OrdersResourceDetailData,
} from './orders-resource-detail/orders-resource-detail.component';
